import {Inject, Injectable} from '@angular/core';
import {HttpBackend, HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CoreResponse} from '@models/app/response/CoreResponse';
import {environment} from '@environments/environment';
import {mapRes} from '@shared/utils/data-parsing/http/ResponseMapper.util';
import {ISendPasswordResetCode} from '@models/data/account/form-data/ISendPasswordResetCode';
import {RequestService} from '@services/http/request/request.service';
import {PractitionerUserData} from '@models/data/auth/AuthPractitionerUserData';
import {APP_CONFIG, AppConfig} from '@src/app.config';

@Injectable({
  providedIn: 'root',
})
export class AccountHttpService {
  private accountEndpoint = `${this.appConfig.baseApiEndpoint}/account`;
  private currentUserEndpoint = `${this.appConfig.angularEndpoint}/currentUser`;

  private endpoints = {
    login: `${this.accountEndpoint}/login`,
    logout: `${this.accountEndpoint}/logout`,
    sendResetPasswordCode: `${this.accountEndpoint}/send-password-reset-code`,
    getCurrentUser: `${this.currentUserEndpoint}`,
  };

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private http: HttpClient,
    private httpBackend: HttpBackend,
    private reqService: RequestService
  ) {
  }

  public login(formData): Observable<CoreResponse> {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      withCredentials: true,
      observe: 'response' as 'response',
    };

    return new HttpClient(this.httpBackend)
      .post(this.endpoints.login, formData, httpOptions)
      .pipe(mapRes);
  }

  public logout(): Observable<CoreResponse> {
    return this.reqService.get(this.endpoints.logout);
  }

  public sendResetPasswordCode(
    formData: ISendPasswordResetCode
  ): Observable<CoreResponse> {
    return this.reqService.post(this.endpoints.sendResetPasswordCode, formData);
  }

  getCurrentUser(): Promise<PractitionerUserData> {
    return this.reqService
      .getAsync(this.endpoints.getCurrentUser)
      .then((res) => res.body);
  }
}
